module.exports = __webpack_public_path__ + "img/icon_2.08fdba2f.png";